export const ACCOUNT_SETUP_WITHDRAW_SUCCESS = 'ACCOUNT_SETUP_WITHDRAW_SUCCESS';
export const ACCOUNT_SETUP_WITHDRAW_FAIL = 'ACCOUNT_SETUP_WITHDRAW_FAIL';
export const ACCOUNT_SETUP_WITHDRAW_CLEAR = 'ACCOUNT_SETUP_WITHDRAW_CLEAR';



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/withdraw/types.js